import React, { Fragment } from 'react';
import styled from 'styled-components';

const icons = {
  counteroffer: 'Sync',
  increase: 'PageAdd',
  award: 'DecisionSolid',
  awardAll: 'CheckList',
  confirmAward: 'CheckMark',
  reject: 'Cancel',
  rejectAll: 'Cancel',
  duplicate: 'Copy',
  reset: 'Refresh',
  edit: 'CircleStop',
  close: 'CircleStop',
  abort: 'CircleStop',
  notifySeller: 'Mail',
};

const descriptions = {
  counteroffer: (t) => (
    <Fragment>
      <ul>
        {t('counteroffer')
          .split('\n')
          .filter((a) => !!a)
          .map((t, i) => (
            <li key={i}>{t}</li>
          ))}
      </ul>
    </Fragment>
  ),
  increase: (t) => (
    <Fragment>
      <ul>
        {t('increase')
          .split('\n')
          .filter((a) => !!a)
          .map((t, i) => (
            <li key={i}>{t}</li>
          ))}
      </ul>
    </Fragment>
  ),
  award: (t) => (
    <Fragment>
      <ul>
        {t('award')
          .split('\n')
          .filter((a) => !!a)
          .map((t, i) => (
            <li key={i}>{t}</li>
          ))}
      </ul>
    </Fragment>
  ),
  awardAll: (t) => (
    <Fragment>
      <ul>
        {t('awardAll')
          .split('\n')
          .filter((a) => !!a)
          .map((t, i) => (
            <li key={i}>{t}</li>
          ))}
      </ul>
    </Fragment>
  ),
  confirmAward: (t) => (
    <Fragment>
      <ul>
        {t('confirmAward')
          .split('\n')
          .filter((a) => !!a)
          .map((t, i) => (
            <li key={i}>{t}</li>
          ))}
      </ul>
    </Fragment>
  ),
  reject: (t) => (
    <Fragment>
      <ul>
        {t('reject')
          .split('\n')
          .filter((a) => !!a)
          .map((t, i) => (
            <li key={i}>{t}</li>
          ))}
      </ul>
    </Fragment>
  ),
  rejectAll: (t) => (
    <Fragment>
      <ul>
        {t('rejectAll')
          .split('\n')
          .filter((a) => !!a)
          .map((t, i) => (
            <li key={i}>{t}</li>
          ))}
      </ul>
    </Fragment>
  ),
  duplicate: (t) => (
    <Fragment>
      <ul>
        {t('duplicate')
          .split('\n')
          .filter((a) => !!a)
          .map((t, i) => (
            <li key={i}>{t}</li>
          ))}
      </ul>
    </Fragment>
  ),
  notifySeller: (t) => (
    <Fragment>
      <ul>
        {t('notifySeller')
          .split('\n')
          .filter((a) => !!a)
          .map((t, i) => (
            <li key={i}>{t}</li>
          ))}
      </ul>
    </Fragment>
  ),
};

const ActionWrapper = styled.section`
  display: flex;
  flex-flow: row wrap;

  justify-content: center;
`;

const ActionItem = styled.a`
  width: 30em;
  height: 32em;
  box-sizing: border-box;
  margin: 1em 2em;

  cursor: pointer;

  border: solid 2px ${(props) => props.theme.palette.themePrimary};
  background: ${(props) => props.theme.palette.themePrimary}00;
  transition: background-color 0.5s;

  display: grid;
  grid: 5em 7em auto / 7em auto;
  grid-template-areas:
    'header header'
    'icon subtitle'
    'description description';

  > i {
    grid-area: icon;
    color: ${(props) => props.theme.palette.themePrimary};
    font-size: 4em;
    font-weight: bold;
    text-align: center;
    padding-top: 2rem;
  }

  > h2 {
    grid-area: header;
    margin: 0;
    font-size: 1.7em;
    line-height: 2.9;
    text-align: center;
    background: ${(props) => props.theme.palette.themePrimary};
    color: #fff;
  }

  > .subtitle {
    grid-area: subtitle;
    font-weight: bold;
    padding: 1em;
  }

  > .description {
    grid-area: description;
    padding: 0 2em;
    font-size: 0.9em;
    ul,
    li {
      margin: 0;
      padding: 0;
    }
    ul {
      margin: 1em 0 0 1em;
    }
  }

  @media only screen and (max-width: 479px) {
    margin: 0.5em;
    height: auto;
    grid-template-areas:
      'header header'
      'data data';
    i {
      display: none;
    }
    div {
      padding: 0 2em;
      ul {
        margin: 1em 0;
      }
    }
    h2 {
      line-height: initial;
      font-size: 1.5em;
      line-height: 1.5;
    }
  }

  &:hover {
    background: ${(props) => props.theme.palette.themePrimary}11;
    box-shadow: 0 0 20px #777;
  }
`;

export default ({
  className,
  store: { availableActions, handleSelectAction },
  theme,
  t,
}) => {
  return (
    <ActionWrapper className={className + ' clearfix'}>
      {availableActions &&
        availableActions.map((item) => (
          <ActionItem
            key={item}
            onClick={handleSelectAction(item)}
            theme={theme}
          >
            <i
              className={`ms-Icon ms-Icon--${icons[item]}`}
              aria-hidden="true"
            ></i>
            <h2>{t(item + ' title')}</h2>
            <div className="subtitle">{t(item + ' subtitle')}</div>
            <div className="description">
              <p>{t('action functionality')}</p>
              {descriptions[item](t)}
            </div>
          </ActionItem>
        ))}
    </ActionWrapper>
  );
};



// WEBPACK FOOTER //
// ./src/app/containers/SaleWizard/components/ActionSelector.jsx